import { useUndo } from '../hooks/useUndo';
import './UndoToast.css';

/** Bottom-anchored, auto-dismissing, one action. Delete and complete both use it. */
export function UndoToast() {
  const { current, run } = useUndo();
  if (!current) return null;

  return (
    <div className="toast" role="status" key={current.id}>
      <span className="toast__message">{current.message}</span>
      <button type="button" className="toast__action" onClick={run}>
        Undo
      </button>
    </div>
  );
}
